import styles from "./styles.module.scss";

const ScrollToTop = () => {
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div onClick={goToTop} className={styles.button}>
      <img src="/icons/arrow.png" width={32} height={32} alt="Arrow Up" />
    </div>
  );
};
export default ScrollToTop;
